import { render, staticRenderFns } from "./InvoiceTemplateLinewise.vue?vue&type=template&id=b5e4a798&scoped=true"
import script from "./InvoiceTemplateLinewise.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplateLinewise.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplateLinewise.vue?vue&type=style&index=0&id=b5e4a798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e4a798",
  null
  
)

export default component.exports